<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized">
  <div *ngIf="!authorized" class="alert alert-danger text-center">
    <h5>You are not authorized to view this page. If you think this is in error, please check the email address you are logged in with and try again.</h5>
  </div>
  <div *ngIf="authorized" class="pt-3">
    <div class="row mb-2">
      <div class="col-md-6">
        <div class="dropdown">
          <h5 *ngIf="!reviewMode && !myPapers">Submissions</h5>
          <h5 *ngIf="reviewMode && myPapers">My Papers To Review</h5>
          <h5 *ngIf="reviewMode && !myPapers">All Papers</h5>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col">
        <ng-container *ngIf="pss.filter">
          <div class="d-block d-md-flex mb-1">
            <!-- <select class="form-control mr-3" (change)="refetch(true)" [(ngModel)]="filter.paperApprovalStatus">
          <option [ngValue]="null">All Active</option>
          <option *ngFor="let item of PaperApprovalStatusEnum | keyvalue" [ngValue]="item.key">{{ item.value }}</option>
        </select> -->
            <kendo-multiselect class="mr-3 mb-1" style="min-width: 200px" (valueChange)="pss.refetch(true)" kendoMultiSelectSummaryTag [checkboxes]="{ checkOnClick: false }" [valuePrimitive]="true" [(ngModel)]="pss.filter.paperApprovalStatus" name="paperApprovalStatus" placeholder="All Active" [autoClose]="false" textField="value" valueField="key" [data]="PaperApprovalStatusEnum | keyvalue">
              <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                <span class="k-icon k-i-arrow-s"></span>
                {{ dataItems.length }} status(s)
              </ng-template>
            </kendo-multiselect>
            <kendo-multiselect class="mr-3 mb-1" style="min-width: 200px" (valueChange)="pss.refetch(true)" kendoMultiSelectSummaryTag [checkboxes]="{ checkOnClick: false }" [valuePrimitive]="true" [(ngModel)]="pss.filter.includedTypes" name="excludedTypes" placeholder="All Types" [autoClose]="false" textField="title" valueField="id" [data]="pss.paperTypes">
              <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                <span class="k-icon k-i-arrow-s"></span>
                {{ dataItems.length }} types
              </ng-template>
            </kendo-multiselect>
            <kendo-multiselect class="mr-3 mb-1" style="min-width: 200px" (valueChange)="pss.refetch(true)" kendoMultiSelectSummaryTag [checkboxes]="{ checkOnClick: false }" [valuePrimitive]="false" [(ngModel)]="pss.filter.tags" name="tags" placeholder="All Tags" [autoClose]="false" textField="label" valueField="id" [data]="pss.tags">
              <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                <span class="k-icon k-i-arrow-s"></span>
                {{ dataItems.length }} tags
              </ng-template>
            </kendo-multiselect>
            <!-- <select class="form-control mr-3 mb-1" (change)="pss.refetch(true)" [(ngModel)]="pss.filter.beforeDeadline">
            <option [ngValue]="null">No Deadline</option>
            <option [ngValue]="true">Before Deadline</option>
            <option [ngValue]="false">After Deadline</option>
          </select> -->
            <select class="form-control mr-3 mb-1" (change)="pss.refetch(true)" [(ngModel)]="pss.filter.paperSubmissionSort">
              <option [ngValue]="null">Sort (Default)</option>
              <option *ngFor="let item of PaperSubmissionSortEnum | keyvalue" [ngValue]="item.key">Sort: {{ item.value }}</option>
            </select>
            <div class="ml-auto d-none d-md-flex">
              <button class="my-auto btn btn-sm btn-outline-secondary" type="button" [promiseBtn]="submitComplete2" (click)="export()">Export</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="Search by title, abstract, submitter, content area, CEU type or ID..." (keyup.enter)="pss.refetch(true)" [(ngModel)]="pss.filter.searchText" />
                <div class="input-group-append">
                  <button class="btn btn-outline-danger" type="button" (click)="pss.filter.searchText = ''; pss.refetch(true)">Clear</button>
                  <button class="btn btn-outline-secondary" type="button" (click)="pss.refetch(true)">Search</button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="multipleChecked" class="d-block d-md-flex mb-1">
          <div class="ml-auto d-none d-md-flex">
            <button type="button" class="btn btn-warning" (click)="convertMultiple()">Convert & Combine</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mt-2">
            <strong class="mt-2 mb-2">Showing {{ pss.resultCount }} Results</strong>
            <table class="table mobile-xs-table table-bordered-outside table-hover mt-2">
              <thead class="bg-light">
                <tr>
                  <th *ngIf="!reviewMode"></th>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Area</th>
                  <th>Duration</th>

                  <!-- <th *ngIf="!reviewMode">Assigned To</th> -->
                  <th *ngIf="!reviewMode">Score</th>
                  <th>Status</th>
                  <th class="text-center" *ngIf="!reviewMode">Converted?</th>
                  <th class="text-center" *ngIf="reviewMode">Reviewed By Me</th>
                  <!-- <th class="text-right">Actions</th> -->
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="pss.searching">
                  <tr *ngFor="let item of [].constructor(20)">
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                  </tr>
                </ng-container>
                <tr *ngIf="pss.papers && pss.papers.length == 0 && !pss.searching">
                  <td colspan="8" class="full-width break-word">
                    <div class="row no-gutters no-candidates" style="height: 300px">
                      <div class="col-sm-12 my-auto">
                        <h1><i class="fas fa-empty-set"></i></h1>
                        <h4>No Submissions</h4>
                        <p>There are no submissions with this filter. Please try another filter or wait for submissions to come in!</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr [id]="'paper' + paper.id" *ngFor="let paper of pss.papers; let idx = index">
                  <td *ngIf="!reviewMode">
                    <input *ngIf="!paper.convertedToEvent && (paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Finalized] || paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Accepted])" type="checkbox" [(ngModel)]="paper.checkedForMerge" />
                  </td>
                  <td class="full-width break-word">
                    <a *ngIf="reviewMode" [routerLink]="['../../', 'review', paper.id]" [queryParams]="{ tab: 4, sourcePage: myPapers ? 'myPapers' : 'allPapers' }">{{ idx + 1 + pss.currentPage * pss.pageSize }}: {{ paper.title }}: {{ paper.title }}<span *ngIf="!paper.title">&lt;No Title&gt;</span></a>
                    <a *ngIf="!reviewMode" [routerLink]="['.', paper.id]">{{ idx + 1 + pss.currentPage * pss.pageSize }}: {{ paper.title }}<span *ngIf="!paper.title">&lt;No Title&gt;</span></a>
                    <span *ngIf="!blindReview" class="d-block">{{ paper.submittingUser.fullName }}</span>
                    <span *ngIf="blindReview" class="d-block"><i>Redacted for Blind Review</i></span>
                    <span class="d-block small mt-1"
                      ><span class="paper-tag" *ngFor="let tag of paper.tags">{{ tag.label }}</span></span
                    >
                  </td>
                  <td style="white-space: nowrap"><span class="mobile-grid-label">Type</span>{{ paper.paperTypeName }}</td>
                  <td><span class="mobile-grid-label">Content Area</span>{{ paper.contentArea }}</td>
                  <td><span class="mobile-grid-label">Duration</span>{{ paper.anticipatedDurationMins }}</td>

                  <!-- <td *ngIf="paper.assignedTo && !reviewMode" style="white-space: nowrap">
                          <img class="avatar u-sm-avatar rounded-circle mr-2" src="fetch-avatar?userId={{ paper.assignedTo?.id }}&width=32&height=32&mode=crop"  />

                        </td> -->
                  <!-- <td *ngIf="!paper.assignedTo && !reviewMode" class="text-muted" style="padding-left: 40px">&lt;unassigned&gt;</td> -->
                  <td *ngIf="!reviewMode" style="white-space: nowrap"><span class="mobile-grid-label">Score</span>{{ paper.score | number: '1.2-2' }} ({{ paper.reviewCount }})</td>
                  <td>
                    <span class="mobile-grid-label">Status</span>
                    <span style="white-space: nowrap" class="paperApprovalStatus" [ngClass]="paper.paperApprovalStatus.toString()"> {{ paper.paperApprovalStatus | enumValue: PaperApprovalStatus:PaperApprovalStatusEnum }}</span>
                  </td>
                  <td class="text-center mobile-force-left" *ngIf="!reviewMode">
                    <span class="mobile-grid-label">Converted</span>
                    <a *ngIf="!paper.convertedToEvent && (paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Finalized] || paper.paperApprovalStatus.toString() == PaperApprovalStatus[PaperApprovalStatus.Accepted]) && !paper.checkedForMerge" href="javascript:void(0);" (click)="convertToEvent(paper)">Convert</a>
                    <span *ngIf="!paper.convertedToEvent && paper.paperApprovalStatus.toString() != PaperApprovalStatus[PaperApprovalStatus.Finalized] && paper.paperApprovalStatus.toString() != PaperApprovalStatus[PaperApprovalStatus.Accepted]">No</span>
                    <span *ngIf="paper.convertedToEvent">Yes</span>
                  </td>
                  <td class="text-center mobile-force-left" *ngIf="reviewMode">
                    <span class="mobile-grid-label">Reviewed by Me?</span>
                    <i *ngIf="paper.currentUserReviewed" class="fas fa-check-circle text-success"></i>
                    <i *ngIf="!paper.currentUserReviewed" class="fas fa-times-circle text-danger"></i>
                  </td>
                  <!-- <td>
                          <div class="dropdown text-right">
                            <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" [routerLink]="['.', paper.id, 'edit']">Edit</a>
                            </div>
                          </div>
                        </td> -->
                </tr>
              </tbody>
            </table>
            <p-paginator [rows]="pss.pageSize" [first]="pss.currentPage * pss.pageSize" [totalRecords]="pss.resultCount" (onPageChange)="pss.paginate($event)" [pageLinkSize]="pageLinkCount" [rowsPerPageOptions]="[10, 20, 30, 50]"></p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
